import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=89a806b0&"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js&"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielmannheimer/plentyDevTool/38033/159/Ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a806b0')) {
      api.createRecord('89a806b0', component.options)
    } else {
      api.reload('89a806b0', component.options)
    }
    module.hot.accept("./LoadingAnimation.vue?vue&type=template&id=89a806b0&", function () {
      api.rerender('89a806b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/LoadingAnimation.vue"
export default component.exports